"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageNcdTable = exports.NcdStepbackTable = exports.NcdInfoSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var NcdInfoSection = function () {
    var _a = React.useState("4"), ncdYears = _a[0], setNcdYears = _a[1];
    var options = [];
    var ncdYearsMap = new Map([
        ["4", "4 years of NCD"],
        ["5", "5-8 years of NCD"],
        ["9", "9+ years of NCD"]
    ]);
    ncdYearsMap.forEach(function (value, key) {
        options.push((0, jsx_runtime_1.jsx)("option", { value: key, children: value }, key));
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "ncd-info-section", children: [(0, jsx_runtime_1.jsx)("p", { className: "mb-2 font-weight-extra-light", children: "No claim discount (NCD) protection means you won\u2019t lose your NCD no matter how many claims you make. This protects your NCD but your price may still increase if you\u2019ve made a claim." }), (0, jsx_runtime_1.jsxs)("div", { className: "mb-2", children: [(0, jsx_runtime_1.jsx)("p", { className: "mb-0 font-weight-semi-bold ncd-section-title", children: "Without protected NCD" }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0 font-weight-extra-light pncd-dropdown-section", children: [(0, jsx_runtime_1.jsx)("span", { children: "If you have" }), (0, jsx_runtime_1.jsx)("select", { id: "pncd-years", className: "form-control inline-control m-2", onChange: function (e) { return setNcdYears(e.target.value); }, value: ncdYears, children: options }), (0, jsx_runtime_1.jsx)("span", { children: "and you make a claim, your NCD at renewal will reduce to..." })] }), (0, jsx_runtime_1.jsx)(exports.NcdStepbackTable, { ncdYears: ncdYears }), (0, jsx_runtime_1.jsx)("div", { className: "light-blue-panel", children: (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "With protected NCD " }), "there's no reduction to your NCD at renewal, no matter how many claims you make."] }) }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0 font-weight-semi-bold mt-3", children: "Average NCD" }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0 font-weight-extra-light", children: "View how your No Claim Discount (NCD) grows over time." }), (0, jsx_runtime_1.jsx)(exports.AverageNcdTable, {})] })] }));
};
exports.NcdInfoSection = NcdInfoSection;
var NcdStepbackTable = function (_a) {
    var ncdYears = _a.ncdYears;
    var tableRows = [];
    var ncdStepbackTriple = [
        { ncdYears: "4", numberOfClaims: "1 claims", ncdAtRenewal: "2 years" },
        { ncdYears: "4", numberOfClaims: "2 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "4", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "5", numberOfClaims: "1 claims", ncdAtRenewal: "3 years" },
        { ncdYears: "5", numberOfClaims: "2 claims", ncdAtRenewal: "1 years" },
        { ncdYears: "5", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "9", numberOfClaims: "1 claims", ncdAtRenewal: "4 years" },
        { ncdYears: "9", numberOfClaims: "2 claims", ncdAtRenewal: "2 years" },
        { ncdYears: "9", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" }
    ];
    ncdStepbackTriple.filter(function (s) { return s.ncdYears === ncdYears; }).forEach(function (value) {
        tableRows.push((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: value.numberOfClaims }), (0, jsx_runtime_1.jsx)("td", { className: "font-weight-semi-bold", children: value.ncdAtRenewal })] }));
    });
    return ((0, jsx_runtime_1.jsxs)("table", { className: "table table-striped ncd-table", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Number of claims" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "NCD at renewal" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: tableRows })] }));
};
exports.NcdStepbackTable = NcdStepbackTable;
var AverageNcdTable = function () {
    var tableRows = [];
    var isBritannia = services_1.resourcesHelper.THEME === 'Britannia';
    var averageNcdMap = new Map([
        ["1", "56%"],
        ["2", "58%"],
        ["3", "61%"],
        ["4", "63%"],
        ["5", "65%"],
        ["6", "66%"],
        ["7", "68%"],
        ["8", "69%"],
        ["9 or more", "71%"]
    ]);
    var averageNcdMapBritannia = new Map([
        ["1", "56%"],
        ["2", "58%"],
        ["3", "61%"],
        ["4", "63%"],
        ["5", "65%"],
        ["6", "66%"],
        ["7", "68%"],
        ["8", "69%"],
        ["9 or more", "71%"]
    ]);
    var ncdMap = isBritannia ? averageNcdMapBritannia : averageNcdMap;
    ncdMap.forEach(function (value, key) {
        tableRows.push((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: key }), (0, jsx_runtime_1.jsx)("td", { className: "font-weight-semi-bold", children: value })] }));
    });
    return ((0, jsx_runtime_1.jsxs)("table", { className: "table table-striped ncd-table", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "NCD years" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Average NCD discount" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: tableRows })] }));
};
exports.AverageNcdTable = AverageNcdTable;
//# sourceMappingURL=NcdInfoSection.js.map